import React from "react";
import "./termsOfService.css";

const TermsOfService = () => {
  return (
    <div className="terms-of-service-container">
      <h1>PhysiTask Terms of Service</h1>
      <p>
        By using the PhysiTask platform, you agree to the following Terms of
        Service. Please read these terms carefully before using our platform.
      </p>

      <h2>1. Eligibility</h2>
      <p>
        To access and use PhysiTask, you must be at least 18 years old and have
        the legal capacity to enter into a binding contract. If you are under
        the age of 18 or do not have the legal capacity to enter into a
        contract, you must not use our platform.
      </p>

      <h2>2. Accounts</h2>
      <p>
        To use certain features of our platform, you must create an account.
        You are responsible for maintaining the confidentiality of your account
        password and for all activities that occur under your account. You must
        notify us immediately if you suspect any unauthorized access or use of
        your account.
      </p>

      <h2>3. User Conduct</h2>
      <p>
        You agree to use PhysiTask for lawful purposes only and in accordance
        with these Terms of Service. You must not engage in any activity that
        is harmful, fraudulent, deceptive, or offensive, or that infringes on
        the rights of others.
      </p>

      <h2>4. Content and Intellectual Property Rights</h2>
      <p>
        By submitting, posting, or displaying content on or through PhysiTask,
        you grant us a non-exclusive, worldwide, royalty-free license to use,
        reproduce, and distribute your content. You represent and warrant that
        you have all the rights, power, and authority necessary to grant the
        rights granted herein to any content that you submit.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, PhysiTask and its affiliates
        shall not be liable for any direct, indirect, punitive, incidental,
        special, consequential, or exemplary damages arising out of or in
        connection with your use of our platform.
      </p>

      <h2>6. Indemnification</h2>
      <p>
        You agree to indemnify, defend, and hold harmless PhysiTask and its
        affiliates from and against any claims, liabilities, damages, losses,
        and expenses, including, without limitation, reasonable legal and
        accounting fees, arising out of or in any way connected with your
        access to or use of our platform, or your violation of these Terms of
        Service.
      </p>

      </div>)};

      export default TermsOfService;

